export default "__VITE_ASSET__CQpYh96o__"